import { createTheme } from "@mui/material/styles";
import { colors, typography, borderRadius, shadows } from "./tokens";

/**
 * Material-UIテーマとデザイントークンの統合
 */
export const lamactTheme = createTheme({
  palette: {
    primary: {
      main: colors.primary[500],
      light: colors.primary[300],
      dark: colors.primary[700],
      contrastText: colors.neutral[0],
    },
    secondary: {
      main: colors.brand.lamact,
      light: "#c8e4fb",
      dark: "#7bb8e8",
      contrastText: colors.neutral[900],
    },
    error: {
      main: colors.semantic.error,
    },
    warning: {
      main: colors.semantic.warning,
    },
    info: {
      main: colors.semantic.info,
    },
    success: {
      main: colors.semantic.success,
    },
    background: {
      default: colors.neutral[0],
      paper: colors.neutral[0],
    },
    text: {
      primary: colors.neutral[900],
      secondary: colors.neutral[600],
      disabled: colors.neutral[400],
    },
    grey: colors.neutral,
  },
  typography: {
    fontFamily: typography.fontFamily.base,
    fontSize: 16,
    h1: {
      fontSize: typography.fontSize["5xl"],
      fontWeight: typography.fontWeight.bold,
      lineHeight: typography.lineHeight.tight,
    },
    h2: {
      fontSize: typography.fontSize["4xl"],
      fontWeight: typography.fontWeight.bold,
      lineHeight: typography.lineHeight.tight,
    },
    h3: {
      fontSize: typography.fontSize["3xl"],
      fontWeight: typography.fontWeight.semibold,
      lineHeight: typography.lineHeight.normal,
    },
    h4: {
      fontSize: typography.fontSize["2xl"],
      fontWeight: typography.fontWeight.semibold,
      lineHeight: typography.lineHeight.normal,
    },
    h5: {
      fontSize: typography.fontSize.xl,
      fontWeight: typography.fontWeight.medium,
      lineHeight: typography.lineHeight.normal,
    },
    h6: {
      fontSize: typography.fontSize.lg,
      fontWeight: typography.fontWeight.medium,
      lineHeight: typography.lineHeight.normal,
    },
    body1: {
      fontSize: typography.fontSize.base,
      lineHeight: typography.lineHeight.normal,
    },
    body2: {
      fontSize: typography.fontSize.sm,
      lineHeight: typography.lineHeight.normal,
    },
  },
  spacing: (factor: number) => `${factor * 4}px`, // MUI標準の4pxベース
  shape: {
    borderRadius: parseInt(borderRadius.base),
  },
  shadows: [
    shadows.none,
    shadows.sm,
    shadows.base,
    shadows.md,
    shadows.lg,
    shadows.xl,
    // MUI要求の24レベル分のシャドウ（残りは拡張）
    ...Array(18).fill(shadows.lg),
  ] as any,
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: colors.neutral[0],
          color: colors.neutral[900],
          boxShadow: shadows.sm,
          borderBottom: `1px solid ${colors.neutral[200]}`,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: borderRadius.base,
          fontWeight: typography.fontWeight.medium,
          transition: "all 0.2s ease-in-out",
          "&:hover": {
            transform: "translateY(-1px)",
            boxShadow: shadows.md,
          },
          "&:focus-visible": {
            outline: `2px solid ${colors.primary[500]}`,
            outlineOffset: "2px",
          },
        },
        contained: {
          boxShadow: shadows.sm,
          "&:hover": {
            boxShadow: shadows.md,
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: borderRadius.lg,
          boxShadow: shadows.base,
          border: `1px solid ${colors.neutral[200]}`,
          transition: "all 0.2s ease-in-out",
        },
      },
    },
    MuiFab: {
      styleOverrides: {
        root: {
          boxShadow: shadows.lg,
          "&:hover": {
            boxShadow: shadows.xl,
          },
          "&:focus-visible": {
            outline: `2px solid ${colors.primary[500]}`,
            outlineOffset: "2px",
          },
        },
      },
    },
  },
});
